import { createSlice } from '@reduxjs/toolkit';

const initialState = [];

const haveLoadedInstance = (state, instance) => state.some((iq) => iq.inquiryId === instance.inquiryId);

export const inquiriesSlice = createSlice({
  name: 'inquiries',
  initialState: initialState,
  reducers: {
    clearInquiries: () => {
      return initialState;
    },

    setInquiries: (state, action) => {
      return action.payload;
    },

    addInquiry: (state, action) => {
      let instance = action.payload;
      if (haveLoadedInstance(state, instance)) {
        return state;
      } else {
        if (!instance.name) {
          const name = instance.firstName.trim() + ' ' + instance.lastName.trim();
          instance = { ...instance, name };
        }
        return state.concat(instance);
      }
    },

    updateInquiry: (state, action) => {
      let instance = action.payload;
      if (!instance.name) {
        const name = instance.firstName.trim() + ' ' + instance.lastName.trim();
        instance = { ...instance, name };
      }
      if (haveLoadedInstance(state, instance)) {
        const others = state.filter((iq) => iq.inquiryId !== instance.inquiryId);
        return others.concat(instance);
      } else {
        return state.concat(instance);
      }
    },

    removeInquiry: (state, action) => {
      const idOfInstanceToRemove = action.payload;
      return state.filter((iq) => iq.inquiryId !== idOfInstanceToRemove);
    },

    bulkChangeInquiryOwnerships: (state, action) => {
      const { oldOwnerId, newOwnerId } = action.payload;
      return state.map((inq) => {
        if (inq.ownerPersonId === oldOwnerId) {
          return { ...inq, ownerPersonId: newOwnerId };
        } else {
          return inq;
        }
      });
    },
  },
});

export const { clearInquiries, setInquiries, addInquiry, updateInquiry, removeInquiry, bulkChangeInquiryOwnerships } =
  inquiriesSlice.actions;

export default inquiriesSlice.reducer;
